export const Icons = {
  ADDRESSES: 'home',
  ASSIGNED_USER: 'person',
  HOTNESS: 'whatshot',
  STATUS: 'info',
  TEXT: 'text_fields',
  CUSTOM_FIELD: 'category',
  DOLLAR_AMOUNT: 'attach_money',
};

export default function(sources, statuses, hotnesses, tags, teamMembers) {
  return {
    personal: [
      {
        label: 'Primary Email',
        name: 'email',
        icon: 'email',
      },
      {
        label: 'Secondary Email',
        name: 'secondary_email',
        icon: 'email',
      },
      {
        label: 'Mobile Number',
        name: 'mobile_phone',
        icon: 'smartphone',
      },
      {
        label: 'Home Number',
        name: 'home_phone',
        icon: 'phone',
      },
      {
        label: 'Office Number',
        name: 'office_phone',
        icon: 'phone',
      },
      {
        label: 'Fax',
        name: 'fax',
        icon: 'print',
      },
      {
        label: 'Company',
        name: 'company',
        icon: 'business',
      },
      {
        label: 'Birthday',
        name: 'birthday',
        type: 'date',
        icon: 'cake',
      },
      {
        label: 'Anniversary',
        name: 'anniversary',
        type: 'date',
        icon: 'cake',
      },
    ],
    spouse: [
      {
        label: 'Spouse Name',
        name: 'spouse_name',
        icon: 'person',
      },
      {
        label: 'Spouse Email',
        name: 'spouse_email',
        icon: 'email',
      },
      {
        label: 'Spouse Phone',
        name: 'spouse_phone',
        icon: 'phone',
      },
      {
        label: 'Spouse Birthday',
        name: 'spouse_birthday',
        type: 'date',
        icon: 'cake',
      },
    ],
    organize: [
      {
        label: 'Contact Source',
        name: 'source_id',
        type: 'select',
        items: sources,
        icon: 'play_for_work',
      },
      {
        label: 'Contact Status',
        name: 'status',
        type: 'select',
        items: statuses,
        icon: Icons.STATUS,
      },
      {
        label: 'Hotness Level',
        name: 'hotness_id',
        type: 'select',
        items: hotnesses,
        icon: Icons.HOTNESS,
      },
      {
        label: 'Tags',
        name: 'tags',
        type: 'autocomplete',
        items: tags,
        icon: 'local_offer',
      },
      {
        label: 'Assigned User',
        name: 'assigned_user_id',
        type: 'select',
        items: teamMembers,
        icon: Icons.ASSIGNED_USER,
      },
      {
        label: 'Comments',
        name: 'comment',
        type: 'textarea',
        icon: 'comment',
      },
    ],
  };
}
